module.exports = __webpack_public_path__ + "static/media/video8.392ae74f.jpg";